<template>
  <v-data-table
    :headers="headers"
    :items="pipelineEvents"
    :items-per-page="30"
    :loading="loading"
    class="elevation-1"
    sort-by="last_timestamp"
    :sort-desc="true"
  >
    <template v-slot:item.status="{ item }">
      <v-chip :color="getStatusColor(item.status)" dark>
        <div class="text-lowercase">
          {{ item.status.replace("_", " ") }}
        </div>
      </v-chip>
    </template>
    <template v-slot:item.action="{ item }">
      <!-- <v-btn icon @click="openEventDialog(item.id)"
        ><v-icon></v-icon></v-btn
      > -->
      <v-btn icon @click="retryEventDialog(item.id)"
        ><v-icon>mdi-eye</v-icon></v-btn
      >
    </template>
  </v-data-table>
</template>

<script>
import { pipeline } from ".";

export default {
  props: {
    pipelineEvents: { type: Array },
    loading: { type: Boolean },
  },
  data() {
    return {
      headers: [
        {
          text: "Timestamp",
          align: "start",
          sortable: false,
          value: "last_timestamp",
        },
        {
          text: "Status",
          sortable: false,
          value: "status",
        },
        { text: "Number", value: "number", sortable: false },
        { text: "Platform", value: "platform", sortable: false },
        {
          text: "Restaurant ID",
          value: "restaurant_platform_id",
          sortable: false,
        },
        {
          text: "Platform Order UUID",
          value: "platform_order_uuid",
          sortable: false,
        },
        { text: "Action", value: "action", sortable: false },
      ],
    };
  },
  methods: {
    getStatusColor: (status) => pipeline.getStatusColor(status),
    openEventDialog(id) {
      this.$emit("open-event-dialog", id);
    },
    retryEventDialog(id) {
      this.$emit("open-retry-dialog", id);
    },
  },
};
</script>
